import { ChangeDetectionStrategy, Component, EventEmitter, Output, ViewEncapsulation } from '@angular/core';
import { FiTextItemMediaPanelItemBaseComponent } from '@fi-app/utilities/insert-media/fi-text-item-media-panel-handler/fi-text-item-media-panel-item-base/fi-text-item-media-panel-item-base.component';

@Component({
    selector: 'fi-text-item-media-panel-settings',
    template: `
        <button mat-icon-button class="fi-text-item-media-panel-action" (click)="menuItemClick()">
            <mat-icon><span class="fa fa-cog"></span></mat-icon>
        </button>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-menu-item-file-settings' },
    standalone: false,
})
export class FiTextItemMediaPanelFileSettingsComponent extends FiTextItemMediaPanelItemBaseComponent {
    @Output() openSettingsDialog = new EventEmitter();

    menuItemClick() {
        this.openSettingsDialog.emit();
    }
}
